import { Clickable, Span, Strong, useStepperContext } from '@ahmdigital/ui';
import React from 'react';
import styled from 'styled-components';

import { InnerWrapper } from '../styles';
import useActiveIndex from '../../../hooks/use-active-index';

const StyledStepName = styled(Span)`
  margin-left: 0.5rem;
`;

const StyledDiv = styled.div`
  position: relative;
`;

type Props = {
  hasStepZero?: boolean;
  isMobileNavExpanded: boolean;
  setIsMobileNavExpanded: (isExpanded: boolean) => void;
};

const MobileNavigation = ({ hasStepZero = false, isMobileNavExpanded, setIsMobileNavExpanded }: Props) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'activeStep' does not exist on type '{}'.
  const { activeStep, steps } = useStepperContext();
  const activeIndex = useActiveIndex();
  const totalSteps = hasStepZero ? steps.length - 1 : steps.length;
  const currentStep = hasStepZero ? activeIndex : activeIndex + 1;

  const handleStepsToggle = () => {
    setIsMobileNavExpanded(!isMobileNavExpanded);
  };

  const chevronName = isMobileNavExpanded ? 'app-chevron-up' : 'app-chevron-down';

  return (
    <StyledDiv>
      <InnerWrapper isMobile isMobileNavExpanded={isMobileNavExpanded}>
        <Clickable onClick={handleStepsToggle} isUnstyled icon={{ name: chevronName, position: 'right' }}>
          <Strong>
            Step {currentStep} of {totalSteps}:
          </Strong>
          <StyledStepName>{activeStep}</StyledStepName>
        </Clickable>
      </InnerWrapper>
    </StyledDiv>
  );
};

export default MobileNavigation;
